import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WatchConfigState, WatchListState } from './watchlist.reducer';

export const getWatchlistState = createFeatureSelector<WatchListState>('watchlist');

export const getWatchConfigs = createSelector(getWatchlistState, (state: WatchListState) => state?.watchConfigs || []);

export const getConfigState = createSelector(getWatchlistState, (state: WatchListState) => {
  return state.configDialogState;
});

export const getMcInstances = createSelector(getConfigState, (state: WatchConfigState) => state.MCInstances);

export const getMCGroups = createSelector(getConfigState, (state: WatchConfigState) =>
  state.MCInstanceGroups.filter(group => group.hasGroupAccess)
);

export const getAllMCGroups = createSelector(getConfigState, (state: WatchConfigState) => state.MCInstanceGroups);

export const getSharedTopics = createSelector(getConfigState, (state: WatchConfigState) => state.sharedTopics);

export const getEditWatchConfig = createSelector(getConfigState, (state: WatchConfigState) => state.watchConfig);

export const getSelectedProfile = createSelector(getWatchlistState, (state: WatchListState) =>
  state.watchConfigs.find(configs => configs.WatchListId === state.selectedConfigId)
);

export const getSelectedWatchListId = createSelector(
  getWatchlistState,
  (state: WatchListState) => state.selectedConfigId
);

export const getWatchlistById = (watchlistId: number) => {
  return createSelector(getWatchlistState, (state: WatchListState) => {
    return state.watchConfigs.find(watch => watch.WatchListId === watchlistId);
  });
};

export const getWLSnoozedDevices = createSelector(getWatchlistState, (state: WatchListState) => {
  return {
    data: state.snoozedDevices,
    tempSnoozeCount: state.tempSnoozedCount,
    permSnoozeCount: state.permSnoozedCount,
  };
});
